import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStagingProduction } from "./stagingProductionSlice";
import { selectStagingSummary, fetchStagingProductionDetail } from "./stagingProductionSlice";
import moment from "moment";
import "moment/locale/id";

moment.locale("id");


export default function StagingProductionPage() {
    const dispatch = useDispatch();

    const summary = useSelector(selectStagingSummary);
    const { data = [], detail, pagination = {}, loading = false, loadingDetail } = useSelector((state) => state.stagingProduction || {});

    const [showDetail, setShowDetail] = useState(false);

    const [filters, setFilters] = useState({
        search: "",
        page: 1,
    });

    const getStatusView = (status) => {
        if (status === 0) return <div className="text-[10px]">Entri Paleting</div>
        if (status === 1) return <div className="text-[10px]">Process BBM</div>
        if (status === 2) return <div className="text-[10px]">Sudah DI BBM</div>
        if (status === 3) return <div className="text-[10px]">Reject</div>
        else return <div className="badge badge-ghost text-[8px]">Entri Paleting</div>
    }

    const handleDetail = (id) => {
        dispatch(fetchStagingProductionDetail(id));
        setShowDetail(true); // modal / drawer
    };

    useEffect(() => {
        dispatch(fetchStagingProduction(filters));
    }, [dispatch, filters]);

    const changePage = (page) => {
        setFilters({ ...filters, page });
    };

    //console.log(data)

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-bold mb-4">Staging Production</h1>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">

                <Card title="Total Data" value={summary.total} color="bg-gray-800" />
                <Card title="Entri Paleting" value={summary.entriPaleting} color="bg-yellow-500" />
                <Card title="Process BBM" value={summary.processBBM} color="bg-blue-600" />
                <Card title="Sudah DI BBM" value={summary.sudahBBM} color="bg-green-600" />
                <Card title="Reject" value={summary.reject} color="bg-red-600" />

            </div>

            <input
                type="text"
                placeholder="Search..."
                className="border px-3 py-2 rounded mb-4"
                onChange={(e) =>
                    setFilters({ ...filters, search: e.target.value, page: 1 })
                }
            />

            <div className="bg-white shadow rounded-xl overflow-hidden">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-100 text-xs uppercase">
                        <tr>
                            <th className="px-4 py-3 text-left">Batch</th>
                            <th className="px-4 py-3 text-left">Created At</th>
                            <th className="px-4 py-3 text-left">Item</th>
                            <th className="px-4 py-3 text-left">Lot</th>
                            <th className="px-4 py-3 text-left">Plan Qty</th>
                            <th className="px-4 py-3 text-left">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="4" className="text-center py-6">
                                    Loading...
                                </td>
                            </tr>
                        ) : (
                            data.map((item) => (
                                <tr
                                    key={item.id}
                                    className="border-t cursor-pointer hover:bg-gray-50"
                                    onClick={() => handleDetail(item.id)}
                                >
                                    <td className="px-4 py-3 text-left">{item.batch_number}</td>
                                    <td className="px-4 py-3 text-left" title={moment(item.created_at).format("DD MMMM YYYY HH:mm:ss")}> {moment(item.created_at).fromNow()}</td>
                                    <td className="px-4 py-3 text-left">{item.item_code}</td>
                                    <td className="px-4 py-3 text-left">{item.lot_number}</td>
                                    <td className="px-4 py-3 text-left">{item.wip_plan_qty}</td>
                                    <td className="px-4 py-3 text-left">{getStatusView(item.status)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-between mt-4">
                <span>
                    Page {pagination?.current_page || 0} of {pagination?.last_page || 0}
                </span>

                <div className="flex gap-2">
                    <button
                        disabled={!pagination.prev_page_url}
                        onClick={() => changePage(pagination.current_page - 1)}
                        className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                        Prev
                    </button>

                    <button
                        disabled={!pagination.next_page_url}
                        onClick={() => changePage(pagination.current_page + 1)}
                        className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                        Next
                    </button>
                </div>
            </div>

            {showDetail && (
                <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
                    <div className="bg-white w-[700px] rounded-xl p-6 shadow-lg">
                        <h2 className="text-xl font-bold mb-4">Detail Staging</h2>

                        {loadingDetail ? (
                            <div>Loading detail...</div>
                        ) : detail ? (
                            <>
                                {/* HEADER */}
                                <div className="grid grid-cols-2 gap-4 mb-4">
                                    <div><b>Batch:</b> {detail.batch_number}</div>
                                    <div><b>Item:</b> {detail.item_code}</div>
                                    <div><b>Lot:</b> {detail.lot_number}</div>
                                    <div><b>Qty Plan:</b> {detail.wip_plan_qty}</div>
                                </div>

                                {/* DETAIL LIST */}
                                <table className="w-full text-sm border">
                                    <thead className="bg-gray-100">
                                        <tr>
                                            <th className="p-2 text-left">Palet</th>
                                            <th className="p-2 textc-center">Qty</th>
                                            <th className="p-2 text-left">Serial</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(detail?.details) &&
                                            detail.details.map((d) => (
                                                <tr key={d.id} className="border-t">
                                                    <td className="p-2 text-left">{d.bin_code}</td>
                                                    <td className="p-2 text-center">{d.qty}</td>
                                                    <td className="p-2 text-left">{d.kode_box}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </>
                        ) : (
                            <div>Tidak ada data</div>
                        )}

                        <div className="mt-4 text-right">
                            <button
                                onClick={() => setShowDetail(false)}
                                className="px-4 py-2 bg-gray-700 text-white rounded"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function Card({ title, value, color }) {
    return (
        <div className={`${color} text-white rounded-xl p-4 shadow`}>
            <div className="text-sm opacity-80">{title}</div>
            <div className="text-2xl font-bold">{value}</div>
        </div>
    );
}